import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TextField,
  Button,
  Paper,
  Box,
  Grid,
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import WSSCheckBoxField from '../../../Components/CheckBox/WSCheckBox';
import { useForm, useFormContext } from 'react-hook-form';
import WSTextField from '../../../Components/TextBox/WSTextBox';
import { WSIcons } from '../../../commonFunctions/iIcons';


const roles = ['Administrator', 'General', 'Front Office', 'Back Office', 'House Keeping',"Night Auditor",'Front Office','Back Office User','House Keeping'];
const privileges = [
  'Property Configuration',
  'Material Management',
  'Food & Beverages',
  'Payroll',
  'Banquet',
  'Gift Card/Voucher',
  'Call Center',

];

export const Previlege:React.FC<any> = React.memo((props) => {
  const {
    register,
    control,
    setValue
  } = useFormContext();
 return (
    <>
    <Grid sx={{ marginBottom: 2 }}>
           <WSTextField
                   label={""}
                   {...register("search")}
                   id="search"
                   name="search"
                   control={control}
                   rules={{ required: false }}
                   labelType="Normal"
   
                 />
           </Grid>
     <TableContainer component={Paper}>
  <Table
    sx={{
      border: '1px solid #ddd',
      '& th': {
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '8px',
      },
      '& td': {
        textAlign: 'center',
        padding: '8px',
        border: '1px solid #ddd',
      },
      '& tr:hover': {
        backgroundColor: '#f9f9f9',
      },
    }}
    stickyHeader
  >
    <TableHead>
      <TableRow>
        <TableCell>Privilege</TableCell>
        {roles.map((role) => (
          <TableCell key={role} align="center">
            {role}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {privileges.map((privilege) => (
        <TableRow key={privilege}>
          <TableCell
            sx={{
              fontWeight: 'medium',
              textAlign: 'left', // Align privilege names to the left for better readability
            }}
          >
            {privilege}
          </TableCell>
          {roles.map((role) => (
            <TableCell key={role}>
              <WSSCheckBoxField
                id={`checkbox-${privilege}-${role}`}
                {...register(`checkbox-${privilege}-${role}`)}
                label=""
                control={control}
                rules={{ required: false }}
                defaultValue={false}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>
    </>
       

     
  );
})

